<template>
  <b-modal 
    :visible="visible" 
    @close="$emit('close')"
    title="Image Preview"
    size="lg"
    centered
    hide-footer
  >
    <div class="text-center">
      <!-- Main Image Display -->
      <div class="mb-4">
        <img 
          :src="imageUrl" 
          class="img-fluid rounded"
          style="max-height: 400px; object-fit: contain;"
          alt="Product image"
        />
      </div>

      <!-- Action Buttons -->
      <div class="d-flex justify-content-center gap-3 mb-3">
        <!-- Set as Main Image Checkbox -->
        <div class="form-check">
          <input 
            class="form-check-input" 
            type="checkbox" 
            :id="'setMain_' + imageIndex"
            :checked="isMainImage"
            @change="toggleMainImage"
            :disabled="isBusy"
          >
          <label class="form-check-label" :for="'setMain_' + imageIndex">
            Set as Main Image
          </label>
        </div>

        <!-- Delete Button -->
        <button 
          type="button" 
          class="btn btn-danger"
          @click="confirmDelete"
          :disabled="isBusy"
        >
          <i class="uil uil-trash-alt me-1"></i>
          Delete Image
        </button>
      </div>

      <!-- Loading Spinner -->
      <div v-if="isBusy" class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Processing...</p>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2';
import Merchandising from '../../../services/Merchandising';

export default {
  name: 'ModalProductImagePreview',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      required: true
    },
    imageIndex: {
      type: Number,
      required: true
    },
    productId: {
      type: [String, Number],
      required: true
    },
    isMainImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isBusy: false
    };
  },
  methods: {
    async toggleMainImage(event) {
      if (event.target.checked) {
        this.$emit('set-main-image', this.imageUrl);
      }
    },

    async confirmDelete() {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure you want to delete this image?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel'
      });

      if (result.isConfirmed) {
        await this.deleteImage();
      }
    },

    async deleteImage() {
      try {
        this.isBusy = true;
        
        const response = await Merchandising.deleteProductImage({
          product_id: this.productId,
          image_url: this.imageUrl
        });
        
        if (response && response.data && response.data.success) {
          this.successmsg('Image deleted successfully!');
          this.$emit('image-deleted', this.imageIndex);
          this.$emit('close');
        } else {
          this.failedmsg(response?.data?.error || 'Failed to delete image');
        }
        
      } catch (error) {
        console.error('Error deleting image:', error);
        this.failedmsg(error.response?.data?.error || 'Failed to delete image');
      } finally {
        this.isBusy = false;
      }
    },

    successmsg(message = 'Operation completed successfully!') {
      Swal.fire({
        position: "center",
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 2000,
      });
    },

    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }
};
</script>

<style scoped>
.gap-3 {
  gap: 1rem;
}
</style>
